module.exports = __webpack_public_path__ + "static/old-portfolio-thumb-af3f90b0d6aad19761b0979f914f3760.png";